<template>
    <div>

        <PageHeader>
            {{ $t('accountSettings.title') }}
        </PageHeader>

        <PersonalSettings />

        <CompanySettings />

        <PasswordSettings />

    </div>
</template>



<script>
    import { loadLanguageAsync, getLocaleFromLanguage } from '@/i18n/i18n';
    import PersonalSettings from './parts/PersonalSettings.vue';
    import CompanySettings from './parts/CompanySettings.vue';
    import PasswordSettings from './parts/PasswordSettings.vue';

    export default {
        name: 'AccountSettings',
        components: {
            PersonalSettings,
            CompanySettings,
            PasswordSettings,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestUser: this.$req('user/Users'),
                requestUserProfile: this.$req('user/Profile'),
                requestUserNotifications: this.$req('user/Notifications'),
                requestUserPassword: this.$req('user/Password'),
                user: {},
            };
        },
        computed: {
            userData() {
                const userData = this.requestUser.getData('patch') || this.requestUser.getData();
                const userProfileData = this.requestUserProfile.getData('patch');
                const user = { ...(userData || {}) };
                if (userProfileData) user.profile = { ...userProfileData };
                return user;
            },
        },
        watch: {
            userData(newValue, oldValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                    this.user = newValue;
                }
            },
        },
        methods: {
            loadUser() {
                const user = this.$store.getters['auth/getUser'];
                const params = { urlParams: { id: user.id } };
                this.requestUser.get(params);
                this.requestUserNotifications.get(params);
            },
            updateUser() {
                const userData = { ...(this.user || {}), ...(this.user?.profile || {}) };
                this.$store.commit('auth/UPDATE_PERSONAL_SETTINGS_SUCCESS', userData);
                this.$store.commit('auth/UPDATE_COMPANY_SETTINGS_SUCCESS', userData);
            },
            updateLanguage() {
                if (this.$i18n.locale !== this.user.profile.language) {
                    loadLanguageAsync(getLocaleFromLanguage(this.user.profile.language));
                }
            },
        },
        created() {
            this.loadUser();
        },
    };
</script>
